import { MxPropertyName } from '@axon-enterprise/track';
export interface AlertMetricPayload {
  [MxPropertyName.Action]?: string;
  [MxPropertyName.FususDeviceCategory]: string;
  [MxPropertyName.FususDeviceBrand]: string;
  [MxPropertyName.DeviceModel]: string;
  [MxPropertyName.DeviceID]: string;
  [MxPropertyName.FususIntegration]: string;
  [MxPropertyName.UserID]: string;
  [MxPropertyName.EventID]: string;
  [MxPropertyName.EventReportID]: string;
  [MxPropertyName.EventReportType]: string;
  [MxPropertyName.SignalEventID]: string;
  [MxPropertyName.NotificationRuleID]: string;
  [MxPropertyName.NotificationID]: string;
  [MxPropertyName.FususDeliveryChannel]: string;
  [MxPropertyName.UserDevice]: string;
  [MxPropertyName.PipeVersion]: string;
  [MxPropertyName.CxVersion]: string;
}

export function createBaseAlertMetricPayload(): AlertMetricPayload {
  return {
    [MxPropertyName.Action]: '',
    [MxPropertyName.FususDeviceCategory]: '',
    [MxPropertyName.FususDeviceBrand]: '',
    [MxPropertyName.DeviceModel]: '',
    [MxPropertyName.DeviceID]: '',
    [MxPropertyName.FususIntegration]: '',
    [MxPropertyName.UserID]: '',
    [MxPropertyName.EventID]: '',
    [MxPropertyName.EventReportID]: '',
    [MxPropertyName.EventReportType]: '',
    [MxPropertyName.SignalEventID]: '',
    [MxPropertyName.NotificationRuleID]: '',
    [MxPropertyName.NotificationID]: '',
    [MxPropertyName.FususDeliveryChannel]: 'In-App',
    [MxPropertyName.UserDevice]: 'Web',
    [MxPropertyName.PipeVersion]: '',
    [MxPropertyName.CxVersion]: '' ,
  };
}
